import axios from '../axios';

class Api {
    static getAllGlastype () {
        return axios.get('/glastype/allbyomschrijving');
    }

    static getListGlastype () {
        return axios.get('/glastype/list');
    }

    static getDetailGlastype (id) {
        return axios.get(`/glastype/${id}`);
    }

    static addGlastype (payload) {
        return axios.post('/glastype', payload);
    }

    static updateGlastype (payload) {
        return axios.post(`/glastype/update/${payload.id}`, payload);
    }

    static deleteGlastype (payload) {
        return axios.post(`/glastype/delete/${payload}`);
    }
}

export default Api;



// WEBPACK FOOTER //
// ./src/api/glastype.js